import ko from "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("autoSelectIfOnlyOne", {
    init: function (element, valueAccessor, allBindings) {
        const listObs = allBindings.get("options");
        const valueObs = allBindings.get("value");
        const optionsValue = allBindings.get("optionsValue");

        if (listObs && valueObs && ko.unwrap(valueAccessor()) !== false) {
            function onListUpdated(newList: any[]) {
                if (newList.length !== 1) {
                    return;
                }

                const value = ko.unwrap(valueObs);
                const optVal = ko.unwrap(optionsValue);
                const onlyExistingValue = optVal ? ko.unwrap(newList[0][optVal]) : ko.unwrap(newList[0]);

                if (value !== onlyExistingValue) {
                    valueObs(onlyExistingValue);
                }
            }

            if (ko.isObservable(listObs)) {
                const subscription = listObs.subscribe(onListUpdated);
                onListUpdated(listObs());

                ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                    subscription.dispose();
                });
            } else {
                onListUpdated(listObs);
            }
        }
    }
});
